import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/common/enums/api-status';
import { getDashboardDetails } from './dashboardThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDashboardDetails.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getDashboardDetails.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.dashboardDetail = action.payload;
        })
            .addCase(getDashboardDetails.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default dashboardSlice.reducer;
